import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { DeviceService } from '@frontend/vanilla/core';

import { ItemComponent } from '../common/item/item.component';
import { ScrollSelectedInViewDirective } from '../directives/scroll-selected-in-view/scroll-selected-in-view.directive';
import { CalendarLayout } from './calendar.service';
import { IntervalLink } from './count-interval.service';
import { TimeFilterTrackingService } from './time-filters-tracking.service';

@Component({
    selector: 'ms-calendar-item-list',
    templateUrl: 'calendar-item-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ScrollAdapterComponent, ScrollSelectedInViewDirective, NgTemplateOutlet, ItemComponent, NgClass],
})
export class CalendarItemListComponent implements OnChanges {
    intervalClass = '';
    title = this.sitecore.globalMessages.CalendarTitle;
    activeInterval: IntervalLink | undefined;
    intervals: IntervalLink[] = [];
    @Input() calendarIntervals: IntervalLink[] = [];
    @Input() layout: CalendarLayout = CalendarLayout.Stacked;
    @Input() location?: string;

    constructor(
        private deviceService: DeviceService,
        private timeFilterTrackingService: TimeFilterTrackingService,
        private sitecore: Sitecore,
    ) {}

    ngOnChanges(): void {
        this.setItemClass();
        this.activeInterval = this.calendarIntervals?.find((interval) => interval.active);
        this.setIntervals();
    }

    private setIntervals(): void {
        if (this.intervals.length !== this.calendarIntervals.length) {
            this.intervals = this.calendarIntervals;

            return;
        }

        const keys = Object.keys(this.intervals);
        for (const key of keys) {
            this.intervals[+key] = this.calendarIntervals[+key];
        }
    }

    private setItemClass(): void {
        let layoutClass = '';
        let layout = this.deviceService.isMobile ? CalendarLayout.MiniCarousel : CalendarLayout.Stacked;

        if (this.layout === CalendarLayout.TilesCarousel) {
            layout = CalendarLayout.TilesCarousel;
        }

        switch (layout) {
            case CalendarLayout.Stacked:
                layoutClass = 'stacked-view';
                break;
            case CalendarLayout.MiniCarousel:
                layoutClass = 'mini-carousel-view';
                break;
            case CalendarLayout.TilesCarousel:
                layoutClass = 'tiles-carousel-view';
                break;
            default:
                layoutClass = '';
                break;
        }

        this.intervalClass = layoutClass;
    }

    get isCarouselLayout(): boolean {
        return this.deviceService.isMobile || this.layout === CalendarLayout.TilesCarousel;
    }

    get showTitle(): boolean {
        return !!this.title && !this.isCarouselLayout;
    }

    trackByInterval(index: number): number {
        return index;
    }

    onItemClicked(link: IntervalLink, intervalIndex: number): void {
        this.timeFilterTrackingService.trackingCalendarNavigation({
            positionEvent: link.title,
            locationEvent: this.location,
            urlClicked: link.url,
            contentPosition: intervalIndex,
        });
    }
}
